class ConflictHandlerRegistry {

    constructor() {
        this._handlers = new Map()
    }

    /**
     *
     * @param reason
     * @param resolverClass
     */
    set(reason, resolverClass) {
        this._handlers.set(reason, resolverClass)
    }

    /**
     *
     * @param reason
     * @returns {any}
     */
    get(reason) {
        return this._handlers.get(reason)
    }
}

export {ConflictHandlerRegistry}
